<div class="kpi">
  <span class="label">{{ label() }}</span>
  <span class="value">{{ value() }}</span>
  @if (sub()) {
    <span class="sub">{{ sub() }}</span>
  }
  <span class="chips">
    @if (badge()) {
      <span class="badge-tag">{{ badge() }}</span>
    }
    @if (mom() !== undefined) {
      <app-delta-chip [value]="mom()" label="МоМ" [invert]="invert()" />
    }
    @if (yoy() !== undefined) {
      <app-delta-chip [value]="yoy()" label="ГоГ" [invert]="invert()" />
    }
  </span>
  <ng-content />
</div>
